import React, { useState,useEffect } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Add_Testslist = () => {
  const [formData, setFormData] = useState({ test_category: "" });
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
 const [catList, setCategoryList] = useState([]);
 const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "test_category") {
      // Find the selected category object
      const selectedCategory = catList.find(cat => cat.test_category === value);
      
      setFormData({
        ...formData,
        test_category: value,  // Store category name
        test_category_id: selectedCategory ? selectedCategory.id : "" // Store category ID
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
useEffect(() => {
        const token = localStorage.getItem("jwt_token");
        const fetchDoctorsList = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/getCategoriesList`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                if (Array.isArray(data.data)) {
                    setCategoryList(data.data);
                    console.log('Doctors:', data);
                } else {
                    console.error('Data is not an array:', data);
                    setCategoryList([]);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchDoctorsList();
    }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const response = await fetch(`${API_BASE_URL}api/addTests`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_token")}`, // Include JWT token if required
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to add category");
      }

      const data = await response.json();
      console.log("Success:", data);

      setShowSnackbar(true);
      setFormData({ test_category: "" }); // Reset input after success

      setTimeout(() => {
        setShowSnackbar(false);
      }, 3000);
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("Failed to add category. Please try again.");
    }
  };

  return (
    <div className="wrapper">
      <Sidebar />
      <main className="main-content content-page">
        <div className="position-relative">
          <Navbar />
        </div>
        <div className="content-inner container-fluid pb-0" id="page_layout">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">New Test Information</h4>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="new-user-info">
                                        <div className="row">
                                            <div className="form-group col-md-6">
                                                <label htmlFor="test_name">Test Name:</label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm my-2"
                                                    id="test_name"
                                                    name="test_name"
                                                    value={formData.test_name}
                                                    onChange={handleInputChange}
                                                />
                                            </div>

                                            <div className="form-group col-md-6">
                                                <label htmlFor="test_code">Test Code:</label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm my-2"
                                                    id="test_code"
                                                    name="test_code"
                                                    value={formData.test_code}
                                                    onChange={handleInputChange}
                                                />
                                            </div>

                                            <div className="form-group col-md-6">
                                                <label htmlFor="test_category">Test Category:</label>
                                                <select
                                                    className="form-control form-control-sm my-2"
                                                    id="test_category"
                                                    name="test_category"
                                                    value={formData.test_category}
                                                    onChange={handleInputChange}>
                                                    <option value="">Select a category</option>
                                                    {catList.map((test_category) => (
                                                        <option key={test_category.id} value={test_category.test_category}>
                                                            {test_category.test_category}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <button type="button" className="btn btn-sm btn-danger-subtle" onClick={() => window.history.back()}>
                                                Cancel
                                            </button>
                                            <button type="submit" className="btn btn-sm btn-primary-subtle">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
      </main>
    </div>
  );
};

export default Add_Testslist;
